import { render, staticRenderFns } from "./BufferSettings.vue?vue&type=template&id=29a6566a&"
import script from "./BufferSettings.vue?vue&type=script&lang=js&"
export * from "./BufferSettings.vue?vue&type=script&lang=js&"
import style0 from "./BufferSettings.vue?vue&type=style&index=0&id=29a6566a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports